module.exports = __webpack_public_path__ + "img/NP11.d9b081aa.jpeg";